import { render, staticRenderFns } from "./StatisticsReport.vue?vue&type=template&id=b27c3932&"
import script from "./StatisticsReport.vue?vue&type=script&lang=js&"
export * from "./StatisticsReport.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports